module.exports = __webpack_public_path__ + "static/media/collection-bird-11-effect.fc405579.png";